/* AJAX LINKS*/

function CategoryFilterClass()
{

    var _this = this;
    this.filterData = {};

    this.init = function ()
    {

    };

    this.filter = function (form)
    {
        if (!form) {
            form = $('form.filter');
        }

        var data = form.serialize();

        var addData = $.param(this.filterData);
        if (addData.length > 0) {
            data = data + '&' + addData;
        }

        form.closest(".part-products").addClass("loading");
        $.ajax({
            data: data,
            url: location.protocol + '//' + location.host + location.pathname // musi byt!!
        }).done(function () {
            form.closest(".part-products").removeClass("loading");
            window.history.pushState("", "", decodeURIComponent('?' + data));
        });
    };

}

var categoryFilter = new CategoryFilterClass();
categoryFilter.init();

$(document).on('click', 'a.ajax', function (e) {
    e.preventDefault();
    var $el = $(this);
    $.ajax({
        url: $el.data('href') ? $el.data('href') : $el.attr('href')
    });
    /*
     .done(function (payload) {
     window.history.pushState("", "", $el.attr('href'));
     });
     */
});

/* AJAX FORM */
$(document).on('submit', 'form.ajax:not(#productDetailProductAdd)', function (e) {
    e.preventDefault();
    var $frm = $(this);
    $.ajax({
        method: $frm.attr('method'),
        url: $frm.attr('action'),
        data: $frm.serialize()
    });
});

$(document).on('submit', '#productDetailProductAdd', function (e) {
    e.preventDefault();
    var $frm = $(this);
    $.ajax({
        method: $frm.attr('method'),
        url: $frm.attr('action'),
        data: $frm.serialize()
    });
});

/* FILTRACE */
$(document).on('change', 'form.filter', function () {
    categoryFilter.filter($(this));
});

$(document).on('click', '[data-category-sort]', function (e) {
    e.preventDefault();
    var $elm = $(this);

    $('form.filter').find('[name="sortType"]').val($elm.attr('data-category-sort'));
    $('form.filter').find('[name="page"]').val(1);
    $('form.filter').find('[name="pageFrom"]').val(1);

    $('[data-category-sort]').removeClass('active');
    $(this).addClass('active');

    categoryFilter.filter();
});

/* PAGE CHANGER */
$(document).on('click', '[data-page]', function () {
    var page = $(this).data('page');
    var pageFrom = $(this).data('page-from');

    $('form.filter').find('[name="page"]').val(page);
    $('form.filter').find('[name="pageFrom"]').val(pageFrom);
    $('form.filter').find('[name="page"]').change();

    if (page == pageFrom) {
        $('html, body').animate({
            scrollTop: $("#snippet-products-paginator").first().offset().top
        }, 800);
    }
});

$(document).on('click', '.ajax-filter .page', function () {
    $('form.filter').find('[name="page"]').val($(this).attr('title')).change();
});

/* CHANGE PRODUCT NUMBER CART */
$(document).on('change', '[data-do="basketUpdate"]', function () {
    var $el = $(this);
    $.ajax({
        data: {
            do: 'basketUpdate',
            productId: $el.data('product-id'),
            count: $el.val()
        }
    });
});

$('[data-show-bestselling]').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $('.part-bestselling .togglable').toggle();
    if ($(this).hasClass('active')) {
        $(this).text($(this).data('hidetext'));
    } else {
        $(this).text($(this).data('showtext'));
        alert(showtext);
    }
});

/* PASSWORD */
function checkpassword(input) {
    if (document.getElementById('f-password-check').value != document.getElementById('f-password').value) {
        document.getElementById('f-password').setCustomValidity('Hesla se musí shodovat.');
    } else {
        document.getElementById('f-password').setCustomValidity('');
    }
}

var options = {
    url: function (phrase) {
        return "?q=" + phrase;
    },
    getValue: "name",
    template: {
        type: "custom",
        method: function (value, item) {
            return '<a href="' + item.uri + '">' +
                    (item.image ? '<img src="' + item.image + '" style="margin-right: 10px" />' : '') +
                    '<div class="wrp"><div class="elm_name">' + item.name + '</div>' +
                    (item.brand ? '<div class="elm_category" style="font-style: italic">' + item.brand + '</div>' : '') +
                    '</div>' +
                    (item.price ? '<span class="elm_price">' + item.price + '</span>' : '') +
                    "</a>";
        }
    },
    list: {
        maxNumberOfElements: 15
    },
    categories: [
        {
            listLocation: "recommended",
            header: "Doporučujeme",
            maxNumberOfElements: 5
        },
        {
            listLocation: "products",
            header: "Produkty",
            maxNumberOfElements: 5
        },
        {
            listLocation: "brands",
            header: "Značky",
            maxNumberOfElements: 5
        },
        {
            listLocation: "categories",
            header: "Kategorie",
            maxNumberOfElements: 10
        }
    ],
    adjustWidth: false,
    requestDelay: 300,
    theme: "square"
};

$(document).ready(function () {
    $("#searchHelp").easyAutocomplete(options);
    $("#searchHelp").on('click', function () {
        if (!$("#searchHelp").val()) {
            var e = $.Event("keyup", {keyCode: 65, which: 65});
            $("#searchHelp").focus();
            $("#searchHelp").val('');
            $("#searchHelp").triggerHandler(e);
            $("#searchHelp").trigger('change');
        }
    });
});

/* GLOBAL AJAX EVENT HANDLER */
$.ajaxSetup({
    success: function (payload) {
        if (payload) {
            if (payload.redirect) {
                if(payload.timeout) {
                    setTimeout(function () {
                        if (payload.redirect == 'this') {
                            location.href = window.location.href.split("#")[0];
                        } else {
                            location.href = payload.redirect;
                        }
                    }, payload.timeout);
                } else {
                    if (payload.redirect == 'this') {
                        location.href = window.location.href.split("#")[0];
                    } else {
                        location.href = payload.redirect;
                    }
                }
            }
            if (payload.snippets) {
                for (var i in payload.snippets) {
                    $("#" + i).replaceWith(payload.snippets[i]);
                }
            }
            if (payload.dialog) {
                $(".part-dialog").remove();
                $("body").addClass("no-scroll-device").append(payload.dialog);
                $("#bgd").fadeIn(300);
                var dialog = $(".part-dialog");
                dialog.addClass("fixed").hide().fadeIn(300);
                var video_width = dialog.find("iframe, video").width();
                var video_height = video_width / (16 / 9);
                dialog.find("iframe, video").css("height", video_height);
            }
            if (payload.alert) {
                alert(payload.alert);
            }
        }
        /*GAsendImpression();*/
    },
    dataType: "json"
});

$(document).on('submit', 'form', function (e) {
    var ref = $(this).find("[required]");

    ref.each(function () {
        if ($(this).val() == '') {
            alert("Vyplňte všechna povinná pole");
            $(this).focus();
            e.preventDefault();
            return false;
        }
    });
    return true;
});

$(document).ready(function () {
    // hodnoceni hvezdickama
    $(document).on('mouseenter', '[data-rate] .icon-star', function () {
        $(this).css('color', '#d83f87').prevAll().css('color', '#d83f87');
    });
    $(document).on('mouseleave', '[data-rate] .icon-star', function () {
        $('[data-rate]').find('.icon-star').each(function () {
            $(this).css('color', $(this).data('color'));
        });
    });

    // ulozenka
    $("#ulozenka").hide();
    if ($('.part-cart-shipping').length) {
        $.ajax({
            url: "https://api.ulozenka.cz/v2/branches?shopId=6182",
            dataType: "json"
        }).done(function (data) {
            var branches = data.data;
            var select = $("#ulozenka");

            for (i = 0; i < branches.length; i++) {
                var branch = branches[i];
                var option = $("<option/>");
                option.val(branch.shortcut);
                option.html(branch.name);
                select.append(option);
            }
        });
    }

    // zavislosti dopravy
    $('input[name=delivery]').change(function () {
        zasilkovnaShow();
    });

    function zasilkovnaShow() {
        var wait = setInterval(function () {
            if ($('#zasilkovna-branch-list [name="pobocka"]').length) {
                var val = $('[name="delivery"]:checked').val();
                if (parseInt(val) === 8) {
                    $('input[id=radio-shipping-8]').closest(".cols").find(".detail").show().find("select").attr("required", "");
                } else {
                    $('input[id=radio-shipping-8]').closest(".cols").find(".detail").hide().find("select").removeAttr("required");
                }
                clearInterval(wait);
            }
        }, 5);
    }
    zasilkovnaShow();

    $(document).on('change', 'input[name=delivery]', function () {
        $.ajax({
            method: "POST",
            data: {value: $('[name="delivery"]:checked').val(), do: 'setDelivery'},
            dataType: 'json'
        });
    });

    $(document).on('change', 'input[name=payment]', function () {
        $.ajax({
            method: "POST",
            data: {value: $('[name="payment"]:checked').val(), do: 'setPayment'},
            dataType: 'json'
        });
    });

    $(document).on('change', '#basketForm :input, #basketForm :radio', function () {
        var formData = $('#basketForm').serialize()
        $.ajax({
            type: "POST",
            data: {formData: formData, do: 'saveform'}
        });
    });

});

// souhlas s podminkami
$(document).on('click', '#submitOrder', function () {
    if ($('#checkbox-conditions').prop('checked') == true) {
        $("#checkSouhlas").hide();
        $('#basketForm').submit();
    } else {
        $("#checkSouhlas").show();
    }
    return false;
});

$(document).on('submit', '#basketForm', function () {
    $('#submitOrder').attr('disabled', 'disabled');
});

// hodnoceni produktu
var rateProduct = function (rate, productId, event) {
    if (rate == 1) {
        var r = confirm("Přejete si hlasovat 1 hvězdičkou?");
    } else {
        var r = confirm("Přejete si hlasovat " + rate + " hvězdičkami?");
    }
    if (r == true) {
        event.preventDefault();
        event.stopPropagation();
        $.ajax({
            url: "?rateProduct",
            method: "post",
            data: {rate: rate}
        }).done(function () {
            $.cookie('rate-' + productId, true, {expires: 7, path: '/'});
        });
    }
};

$(document).ready(function () {
    // aktivace slevoveho kuponu
    $(document).on('click', '#applyBasketCode', function () {
        $('#notExists, #notActive, #notValid, #notMinPrice, #sumaCode').hide();
        $.ajax({
            type: 'POST',
            url: '/ajax/slevove-kupony/',
            data: {basketCode: $('#basketCode').val(), status: 'setCode'},
            dataType: 'json'
        }).done(function (obj) {
            // vse v poradku - a kurva jestli nebudou lidi psat komentare tak tohle je muj posledni at se poserou
            if (obj.result == 'ok' || obj.result == 'used') {
                window.location.href = window.location.href.split('#')[0];
            }
            // neexistuje
            if (obj.result == 'not-exists') {
                $('#notExists').show();
            }
            // neaktivovan
            if (obj.result == 'not-active') {
                $('#notActive').show();
            }
            // nevalidni
            if (obj.result == 'not-valid') {
                $('#notValid').show();
            }
            // malo penez
            if (obj.result == 'not-min-price') {
                $('#notMinPrice').show();
                $('#minPrice').text(obj.minPrice);
            }
        });
        return false;
    });

    // smazani slevoveho kuponu
    $(document).on('click', '#deleteBasketCode', function () {
        $('#notExists, #notActive, #notValid, #notMinPrice, #sumaCode').hide();
        $.ajax({
            type: 'POST',
            url: '/ajax/slevove-kupony/',
            data: {status: 'delCode'},
            dataType: 'json'
        }).done(function (obj) {
            window.location.href = window.location.href.split('#')[0];
        });
        return false;
    });

});

function saveEmail(mail) {
    $.ajax({
        data: {do: 'saveMail', email: mail}
    });
    return false;
}

$(window).on('load', function () {
    if ($("body").filter("[data-sklik]").length) {
        eshopDomainConfirm('www.eroticstore.cz');
    }
});

$(document).ready(function () {
    $('#brands, #category').select2();
});

$(document).on("change", "[name='pobocka']", function () {
    $("[name='deliveryMethodZasilkovna']").attr('value', $(this).find('option:checked').attr('value'));
});